import * as S from "./ChevronIcon.styled";

function ChevronIcon() {
  return <S.ChevronIcon aria-hidden="true" />;
}

export default ChevronIcon;
